// src/ui/screens/chats/widgets/SearchBar.jsx

import React, { useState, useRef, useEffect } from 'react';

const COLORS = {
  card: '#23262C',
};

// ── SearchBar ────────────────────────────────────────────────────────────────

export const SearchBar = ({
  onSearch,
  placeholder = 'Search',
  initialValue = '',
  autoFocus = false,
}) => {
  const [value, setValue] = useState(initialValue);
  const [isTyping, setIsTyping] = useState(initialValue.length > 0);
  const inputRef = useRef(null);

  // ── Handle search input change ───────────────────────────────────────────

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    setIsTyping(newValue.length > 0);
    if (onSearch) {
      onSearch(newValue);
    }
  };

  // ── Clear search ──────────────────────────────────────────────────────────

  const handleClear = () => {
    setValue('');
    setIsTyping(false);
    if (onSearch) {
      onSearch('');
    }
    inputRef.current?.focus();
  };

  // ── Auto focus ─────────────────────────────────────────────────────────────

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [autoFocus]);

  // ── Render ─────────────────────────────────────────────────────────────────

  return (
    <div className="px-4 py-2">
      <div
        className="relative h-11 rounded-full overflow-hidden"
        style={{ backgroundColor: COLORS.card }}
      >
        {/* Search Input */}
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={handleChange}
          className="w-full h-full bg-transparent text-white text-sm outline-none px-3"
          placeholder=""
        />

        {/* Centered placeholder - shown when empty */}
        {!isTyping && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="flex items-center gap-1.5">
              <svg
                className="w-4.5 h-4.5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <span className="text-gray-400 text-sm font-normal">
                {placeholder}
              </span>
            </div>
          </div>
        )}

        {/* Clear button - shown when typing */}
        {isTyping && (
          <button
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full flex items-center justify-center"
            style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
          >
            <svg
              className="w-3.5 h-3.5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;